import React, { useEffect } from "react";
// import React, { useState, useEffect } from "react";
import useSettings from "stores/settings";
import styled from "@emotion/styled";

const FileCard = ({ title, filename, filePath }) => {
  return (
    <div className="glass mx-2 my-4">
      <div className="info">
        <div className="name">
          <h2 className="font-bold fontsize-20">{title}</h2>
          <p className="h-8 mt-2">{filename}</p>
        </div>
        <div className="btn">
          <button>
            <a href={filePath} download>
              다운로드
            </a>
          </button>
        </div>
      </div>
    </div>
  );
};

const NewsCard = ({ title, desc, linkPath }) => {
  return (
    <div className="glass mx-2 my-4">
      <div className="info">
        <div className="name">
          <h2 className="font-bold fontsize-20">{title}</h2>
          <p className="h-8 mt-2">{desc}</p>
        </div>
        <div className="btn">
          <button>
            <a href={linkPath} target="_blank" rel="noreferrer">
              기사보기
            </a>
          </button>
        </div>
      </div>
    </div>
  );
};

const Resource = () => {
  const settings = useSettings();
  // const [isLoading, setLoading] = useState(true);

  useEffect(() => {
    settings.currentMenu = "resource";
    // setLoading(false);
  }, []);

  // if (isLoading) return <div></div>;

  return (
    <section className="section3 w-full h-full overflow-y-scroll section3_bg">
      <div className="max-w-7xl mx-auto px-2 sm:px-4 py-32">
        <DevideWrap2>
          <NewsCard
            title="산업뉴스 [산업방송 채널i]"
            desc="엔키노에이아이(Enkino AI), 기업 맞춤형 AI 도입 길 열다"
            linkPath="https://youtu.be/wwA8pRe7tn8?si=o7o2P0AtPJhtZ0b3"
          />
          <NewsCard
            title="전자신문"
            desc="엔키노, 클라우드 기반 SaaS 플랫폼 'AI Love School' 선보여"
            linkPath="https://www.etnews.com/20241213000283"
          />
          <NewsCard
            title="아이티비즈"
            desc="AI 기술로 터널공사 시공안전성 높인다"
            linkPath="https://www.it-b.co.kr/news/articleView.html?idxno=71331"
          />
          <NewsCard
            title="cosinkorea.com"
            desc="엔키노, 오토 머신러닝 솔루션 '베이바이오텍'에 공급"
            linkPath="https://www.cosinkorea.com/news/article.html?no=49914"
          />
          <NewsCard
            title="테크월드 기사"
            desc="엔키노, 클라우드 기반 IoT SaaS 플랫폼 선봬"
            linkPath="https://www.epnc.co.kr/news/articleView.html?idxno=238677"
          />
          <NewsCard
            title="IT비즈뉴스 기사"
            desc="엔키노(주), 클라우드 기반 IoT SaaS 플랫폼 ‘IoT Auto Maker’ 론칭"
            linkPath="https://www.itbiznews.com/news/articleView.html?idxno=118443"
          />
          <NewsCard
            title="전자신문 기사"
            desc="엔키노, 오토 머신러닝 솔루션을 통한 머신러닝 기반의 데이터 분석 시장 본격 진출"
            linkPath="https://www.etnews.com/20221024000242"
          />
          <NewsCard
            title="입주기업 인터뷰"
            desc="누구나 가볍게 즐기는 AI플랫폼 AISO - 성기범 대표"
            linkPath="https://smartcontentcenter.tistory.com/1389"
          />
          <NewsCard
            title="IT비즈뉴스 기사"
            desc="AI 기술로 터널공사 시공안전성 높여"
            linkPath="https://www.itbiznews.com/news/articleView.html?idxno=115273"
          />
          <NewsCard
            title="에이빙(AVING) 기사"
            desc="엔키노, 베이바이오텍에 오토 머신러닝 솔루션 ‘AISO Data Analysis 2.0’ 공급... “양질의 AI 피부진단 서비스 위해 협력”"
            linkPath="https://kr.aving.net/news/articleView.html?idxno=1785527"
          />
        </DevideWrap2>
        <DevideWrap2 className="mt-16">
          <FileCard title="AISO 소개서" filename="aiso_v1.0.pdf" filePath="/pdf/aiso_v1.0.pdf" />
          <FileCard title="AISO Data Analysis 소개서" filename="aiso_data_v1.0.pdf" filePath="/pdf/aiso_data_v1.0.pdf" />
          <FileCard title="AI PHM 빅데이터 플랫폼 소개서" filename="ai_phm_bigdata_v1.0.pdf" filePath="/pdf/ai_phm_bigdata_v1.0.pdf" />
          <FileCard
            title="AISO Data Analysis 라이센스 정책"
            filename="aiso_data_analysis_license_v1.0.pdf"
            filePath="/pdf/aiso_data_analysis_license_v1.0.pdf"
          />
        </DevideWrap2>
      </div>
    </section>
  );
};

export default Resource;

const DevideWrap2 = styled.div`
  width: 100%;
  display: flex;
  flex-flow: row wrap;
  > .glass {
    width: calc(100% / 3 - 1rem);
  }

  @media (max-width: 1024px) {
    margin: 0 auto;
    > .glass {
      width: calc(100% / 2 - 1rem);
    }
  }
  @media (max-width: 768px) {
    display: block;
    > .glass {
      margin: 1rem 0;
      width: 100%;
    }
  }
`;
